import _Vue from 'vue';

type ShareType = 3 | 6 | 11 | 12 | 13 | 16;
export interface ShareOption {
  title: string;
  url: string;
  subtitle?: string;
  // classId: number | string; // -1
  id: number | string; // -1
  image?: string;
  type: ShareType;
  columnId: number | string;
}
export default {
  install(Vue: typeof _Vue) {
    Vue.prototype.$appShareInfo = (data: any) => {
      setTimeout(() => {
        window.openApp('mSetShareInfo', JSON.stringify(data));
        // if (window.handleMessage) {
        //   window.handleMessage(JSON.stringify(option));
        // }
      }, 500);
    };
    console.log('启动app分享成功');
  },
};
